/* Sélecteur de coloris — produits à variantes de couleur
 *
 * Au clic sur une pastille, cinq choses changent sans que la page bouge :
 * les photos, le nom affiché, l'accroche sous les pastilles, le texte long,
 * et surtout l'identifiant de variante envoyé au panier.
 *
 * Ce dernier point est le seul qui ne se voit pas et le seul qui casse une
 * vente s'il est oublié.
 *
 * Deux façons de montrer les photos, choisies toutes seules :
 *
 *  — MODE GALERIE. Les photos du coloris sont déjà dans la page : on masque
 *    celles des autres coloris et on active la première. Les vignettes, les
 *    points et le glissement du thème continuent de fonctionner sur ce qui
 *    reste. C'est le mode d'un modèle à deux ou trois coloris qui ont chacun
 *    plusieurs vues.
 *
 *  — MODE VUE UNIQUE. Les photos ne sont pas dans la page : la section plafonne
 *    la galerie (réglage max_thumbs, 7 par défaut), donc au-delà d'une poignée
 *    de coloris la plupart n'ont aucune diapositive. On réduit alors la galerie
 *    à un cadre unique et on remplace la source. C'est le mode d'Already Late
 *    et de ses 22 coloris à une photo.
 *
 * 20/09/2026 — LA DEUXIÈME RANGÉE. Quand le produit porte une seconde option
 * (la couleur de la boucle), une rangée de pastilles s'ajoute sous la première
 * et l'identifiant envoyé au panier devient celui du COUPLE : le coloris seul ne
 * suffit plus à le désigner. Le couple est résolu dans la table `variantes`
 * fournie par qt-color.liquid ; à défaut de table, on retombe sur la variante
 * portée par le coloris, c'est-à-dire sur le comportement d'avant.
 *
 * La même table porte la photo de chaque couple : cliquer un coloris change le
 * tissu en gardant la boucle, cliquer une boucle change la boucle en gardant le
 * tissu. Voir photoDe().
 */
(function () {
  'use strict';

  var socle = document.getElementById('qt-colors-data');
  if (!socle) return;

  var data;
  try { data = JSON.parse(socle.textContent); } catch (e) { return; }
  var couleurs = (data.couleurs || []).filter(function (c) { return c && c.variante; });
  if (!couleurs.length) return;
  var visibles = data.visibles || 5;

  // La seconde option, s'il y en a une. Une seule valeur ne vaut pas une rangée :
  // un choix qui n'en est pas un encombre la fiche sans rien décider.
  var boucles = (data.boucles || []).filter(function (b) { return b && b.nom; });
  if (boucles.length < 2) boucles = [];
  var table = data.variantes || null;
  var boucle = boucles.length ? boucles[0].nom : '';

  function coupleDe(nomCouleur, nomBoucle) {
    if (!table) return null;
    return table[nomCouleur + '::' + (nomBoucle || '')] || null;
  }

  // L'identifiant à envoyer au panier. Le couple d'abord, le coloris ensuite :
  // si la table manque une combinaison, mieux vaut vendre la boucle par défaut
  // que rien du tout.
  function varianteDe(c) {
    var v = coupleDe(c.nom, boucle);
    return v && v.id ? v.id : c.variante;
  }

  /* La photo de la variante exactement choisie — coloris ET boucle.
   *
   * C'est ce qui distingue les deux rangées à l'écran : cliquer un coloris
   * change le tissu en gardant la boucle, cliquer une boucle change la boucle
   * en gardant le tissu. Les deux passent par ici.
   *
   * Tant qu'une variante n'a pas de photo propre — le cas de tout ce qui n'est
   * pas encore photographié avec sa boucle acier — on retombe sur la photo du
   * coloris. La fiche reste juste, elle est seulement moins précise. */
  function photoDe(c) {
    var v = coupleDe(c.nom, boucle);
    return (v && v.photo) || c.vues[0] || c.photo || '';
  }

  // L'accroche est le dernier paragraphe du texte du coloris. Liquid ne sait pas
  // l'extraire proprement, on le fait ici une fois pour toutes.
  couleurs.forEach(function (c) {
    c.vues = String(c.photos || '').split('|').filter(Boolean);
    if (!c.vues.length && c.photo) c.vues = [c.photo];
    if (c.accroche || !c.texte) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = c.texte;
    var p = tmp.querySelectorAll('p');
    c.accroche = p.length ? p[p.length - 1].textContent.trim() : '';
  });

  // Relevés au montage, pas ici : l'éditeur de thème re-rend la section produit
  // et remplace ces nœuds. Voir assurer() en bas de fichier.
  var panel = null;
  var buy = null;
  var pdp = null;
  var solo = false;     // true = mode vue unique
  var courant = null;   // le coloris affiché, que la rangée de boucle doit connaître

  /* true quand AUCUNE valeur de la première option ne porte de photo propre.
   * C'est le cas des Designed Bands dont l'option unique est la boucle : le
   * bracelet est photographié sous quatre angles, et aucune de ces vues
   * n'appartient à une boucle plutôt qu'à l'autre. Le moteur laisse alors la
   * galerie entière et ne s'occupe que de l'identifiant de variante — sans
   * quoi il réduirait la fiche à une seule photo pour trier des vues qui n'ont
   * rien à trier. */
  var sansPhotos = false;

  // ── repérage des photos dans la page ────────────────────
  // Les URL du JSON et celles du DOM ne portent pas la même largeur : on
  // compare donc les noms de fichier, qui eux ne changent pas.
  function fichier(url) {
    return String(url || '').split('/').pop().split('?')[0];
  }

  function indicesDe(c) {
    var voulues = c.vues.map(fichier);
    var slides = document.querySelectorAll('.mm-slide');
    var out = [];
    for (var i = 0; i < slides.length; i++) {
      var im = slides[i].querySelector('img');
      if (!im) continue;
      if (voulues.indexOf(fichier(im.getAttribute('src') || im.src)) > -1) out.push(i);
    }
    return out;
  }

  // Le mode se décide une fois, au montage : si chaque coloris retrouve toutes
  // ses photos dans la page, on filtre ; sinon on remplace la source.
  function galeriePossible() {
    for (var i = 0; i < couleurs.length; i++) {
      if (indicesDe(couleurs[i]).length !== couleurs[i].vues.length) return false;
      if (!couleurs[i].vues.length) return false;
    }
    return true;
  }

  function montrer(el, oui) {
    if (!el) return;
    el.style.display = oui ? '' : 'none';
  }

  function filtrerGalerie(c) {
    var idx = indicesDe(c);
    if (!idx.length) return false;

    /* La vue mise en avant est celle de la variante quand la galerie la porte :
     * sans ce repérage, changer de boucle laisserait la photo du coloris en
     * place et le choix ne se verrait pas. */
    var actif = idx[0];
    var voulue = fichier(photoDe(c));
    for (var k = 0; k < idx.length; k++) {
      var im0 = document.querySelectorAll('.mm-slide')[idx[k]].querySelector('img');
      if (im0 && fichier(im0.getAttribute('src') || im0.src) === voulue) { actif = idx[k]; break; }
    }

    /* Les diapositives des autres coloris sont masquées en dur, et celles du
     * coloris rendues au thème (display vide, pas 'block') : sur ordinateur
     * c'est sa classe `on` qui décide laquelle des trois s'affiche, et sous
     * 760 px la scène devient un rail où les trois défilent côte à côte.
     * Sans ce masquage, le rail du téléphone laisse glisser jusqu'aux photos
     * de l'autre coloris — six vues pour un bracelet qu'on n'a pas choisi. */
    ['.mm-slide', '.mm-thumb', '.mm-dot'].forEach(function (sel) {
      var els = document.querySelectorAll(sel);
      for (var i = 0; i < els.length; i++) {
        var dedans = idx.indexOf(i) > -1;
        montrer(els[i], dedans);
        els[i].classList.toggle('on', i === actif);
        if (sel === '.mm-dot') els[i].setAttribute('aria-selected', String(i === actif));
      }
    });

    // une seule vue dans le coloris : la rangée de vignettes et les points
    // n'ont plus rien à proposer
    var plusieurs = idx.length > 1;
    montrer(document.querySelector('.mm-thumbs'), plusieurs);
    montrer(document.querySelector('.mm-dots'), plusieurs);

    /* La galerie est une grille « 52px 1fr » : une piste pour la rangée de
     * vignettes, une pour la scène. Masquer les vignettes en display:none les
     * sort de la grille — et la scène glisse dans la piste de 52 px. La photo
     * du produit tombait alors à 52 px de large. Le CSS rend la grille à une
     * seule colonne tant que cette classe est posée. */
    var gal = document.querySelector('.mm-gallery');
    if (gal) gal.classList.toggle('mm-no-thumbs', !plusieurs);

    /* Sous 760 px la scène n'est pas une pile mais un rail : les vues du coloris
     * y défilent côte à côte, toutes visibles, et la classe `on` n'y décide plus
     * rien. Remettre le rail à zéro montrait donc toujours la PREMIÈRE vue du
     * coloris : changer de boucle ne changeait rien à l'écran, alors que la photo
     * du couple était là, à un glissement de doigt. On amène le rail sur la vue
     * active. Sur ordinateur la scène ne défile pas et une seule vue est rendue :
     * l'écart est nul, l'opération ne fait rien. */
    var stage = document.querySelector('.mm-stage');
    if (stage) {
      var vue = document.querySelectorAll('.mm-slide')[actif];
      if (vue) {
        stage.scrollLeft += vue.getBoundingClientRect().left - stage.getBoundingClientRect().left;
      } else {
        stage.scrollLeft = 0;
      }
    }
    return true;
  }

  /* Mode vue unique : on remplace la source de la seule vue affichée.
   * On charge d'abord la photo en coulisses, et on ne la pose qu'une fois
   * prête. Sans cela la vue se vide le temps du téléchargement : sur une
   * connexion mobile moyenne, le client voit un cadre blanc pendant une
   * seconde et croit que le coloris n'a pas d'image. */
  function remplacerPhoto(c) {
    var vue = document.querySelector('.mm-slide img');
    if (!vue) return;

    var url = aLargeur(photoDe(c), 1000);
    if (!url) return;
    var legende = data.titre + ' — ' + c.nom;

    function poser() {
      vue.loading = 'eager';
      vue.removeAttribute('srcset');
      vue.removeAttribute('sizes');
      vue.src = url;
      vue.alt = legende;
    }

    var pre = new Image();
    pre.onload = poser;
    pre.onerror = poser;   // au pire, laisser le navigateur retenter lui-même
    pre.src = url;
    if (pre.complete) poser();   // déjà en cache : pas d'attente

    var stage = document.querySelector('.mm-stage');
    if (stage && stage.scrollLeft) stage.scrollLeft = 0;
  }

  // Les URL rendues par Liquid portent déjà leur largeur : en rajouter une
  // seconde donnerait ?width=1400&width=1000.
  function aLargeur(url, px) {
    if (!url) return '';
    return /[?&]width=/.test(url) ? url.replace(/([?&])width=\d+/, '$1width=' + px)
                                  : url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + px;
  }

  /* Habille une pastille : image de tissu, couleur unie, ou dégradé de métal.
   * En inline et en !important : le reset de boutons du thème applique un
   * raccourci `background:` qui remet size à auto et position à 0 0 — la
   * pastille n'affiche alors qu'un carré de 34 px pris dans le coin de
   * l'image, c'est-à-dire un aplat uni au lieu du tissu. */
  function habiller(b, spec) {
    if (spec.pastille) {
      b.style.setProperty('background-image', 'url(' + spec.pastille + ')', 'important');
      b.style.setProperty('background-size', 'cover', 'important');
      b.style.setProperty('background-position', 'center', 'important');
      b.style.setProperty('background-repeat', 'no-repeat', 'important');
    } else if (spec.degrade) {
      b.style.setProperty('background-image', spec.degrade, 'important');
      b.style.setProperty('background-size', 'cover', 'important');
    } else if (spec.teinte) {
      b.style.setProperty('background-image', 'none', 'important');
      b.style.setProperty('background-color', spec.teinte, 'important');
    }
  }

  function construire() {
    pdp = document.querySelector('.mm-pdp');
    sansPhotos = couleurs.every(function (c) { return !c.vues.length; });
    solo = !sansPhotos && !galeriePossible();

    var bloc = document.createElement('div');
    bloc.className = 'mm-colors';

    var label = document.createElement('p');
    label.className = 'mm-colors__label';
    label.innerHTML = (data.mot || 'Coloris') + ' <span class="mm-colors__name"></span>' +
      '<span class="mm-colors__count">' + couleurs.length + ' ' +
      (data.dispo || 'disponibles') + '</span>';

    var row = document.createElement('div');
    row.className = 'mm-colors__row';

    couleurs.forEach(function (c, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mm-swatch';
      b.dataset.rank = i < visibles ? 'head' : 'rest';
      b.dataset.couleur = c.nom;
      habiller(b, c);
      b.setAttribute('aria-pressed', String(i === 0));
      b.setAttribute('aria-label', c.nom);
      b.title = c.nom;
      b.addEventListener('click', function () { choisir(c.nom); });
      row.appendChild(b);
    });

    var reste = couleurs.length - visibles;
    if (reste > 0) {
      var more = document.createElement('button');
      more.type = 'button';
      more.className = 'mm-colors__more';
      more.textContent = '+' + reste;
      more.setAttribute('aria-expanded', 'false');
      more.addEventListener('click', function () {
        var ouvert = bloc.classList.toggle('is-open');
        more.textContent = ouvert ? '−' : '+' + reste;
        more.setAttribute('aria-expanded', String(ouvert));
      });
      row.appendChild(more);
    }

    var note = document.createElement('p');
    note.className = 'mm-colors__note';

    // La rangée de la boucle passe en PREMIER : c'est le choix le plus court
    // (deux pastilles), il se règle d'un coup d'œil, et l'accroche du coloris
    // reste ainsi collée aux pastilles qui la concernent.
    if (boucles.length) {
      var bloc2 = document.createElement('div');
      bloc2.className = 'mm-colors__second';

      var label2 = document.createElement('p');
      label2.className = 'mm-colors__label';
      label2.innerHTML = (data.mot2 || 'Boucle') + ' <span class="mm-colors__name2"></span>';

      var row2 = document.createElement('div');
      row2.className = 'mm-colors__row';

      boucles.forEach(function (bo) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'mm-swatch';
        btn.dataset.boucle = bo.nom;
        habiller(btn, bo);
        btn.setAttribute('aria-label', bo.nom);
        btn.title = bo.nom;
        btn.addEventListener('click', function () { choisirBoucle(bo.nom); });
        row2.appendChild(btn);
      });

      bloc2.appendChild(label2);
      bloc2.appendChild(row2);
      bloc.appendChild(bloc2);
    }

    bloc.appendChild(label);
    bloc.appendChild(row);
    bloc.appendChild(note);

    buy.parentNode.insertBefore(bloc, buy);

    // Signale au CSS que notre sélecteur est en place : c'est lui qui masque
    // le sélecteur natif du thème. Marquer ici, et pas plus tôt, garantit que
    // le doublon ne disparaît jamais sans que le nôtre l'ait remplacé.
    panel.classList.add('mm-has-colors');
    if (pdp) {
      pdp.classList.add('mm-has-colors');
      if (solo) pdp.classList.add('mm-colors-solo');
    }

    preparerDescription();
    choisir(depart().nom, true);
  }

  // Le coloris de départ est celui que l'adresse demande (?variant=), sinon le
  // premier. Sans cela un lien partagé ouvre la bonne variante côté panier mais
  // la mauvaise photo à l'écran.
  function depart() {
    var v = new URLSearchParams(window.location.search).get('variant');
    if (v) {
      // Avec deux options, l'identifiant de l'adresse désigne un couple, et la
      // table est seule à porter ses deux moitiés : sans cette lecture, un lien
      // partagé sur la boucle acier rouvrirait sur la boucle noire.
      var cle = cleDe(v);
      if (cle) {
        var moities = cle.split('::');
        var trouve = couleurs.filter(function (x) { return x.nom === moities[0]; })[0];
        if (trouve) {
          if (moities[1]) boucle = moities[1];
          return trouve;
        }
      }
      var c = couleurs.filter(function (x) { return String(x.variante) === String(v); })[0];
      if (c) return c;
    }

    /* Sans rien dans l'adresse, on ouvre sur ce que montre la PREMIÈRE IMAGE du
     * produit : c'est elle que le client vient de voir sur l'accueil ou dans une
     * collection, et arriver sur une autre boucle que celle qu'il a cliquée est
     * le genre de décalage qu'on ne s'explique pas. Le marchand n'a donc qu'une
     * chose à décider — quelle photo met-il en tête — et la fiche suit. */
    var prin = fichier(data.principale);
    if (prin) {
      if (table) {
        var cles = Object.keys(table);
        for (var i = 0; i < cles.length; i++) {
          if (fichier(table[cles[i]].photo) !== prin) continue;
          var moities2 = cles[i].split('::');
          for (var k = 0; k < couleurs.length; k++) {
            if (couleurs[k].nom !== moities2[0]) continue;
            if (moities2[1]) boucle = moities2[1];
            return couleurs[k];
          }
        }
      }
      for (var n = 0; n < couleurs.length; n++) {
        if (fichier(couleurs[n].vues[0] || couleurs[n].photo) === prin) return couleurs[n];
      }
    }

    return couleurs[0];
  }

  function cleDe(id) {
    if (!table) return '';
    var cles = Object.keys(table);
    for (var i = 0; i < cles.length; i++) {
      if (String(table[cles[i]].id) === String(id)) return cles[i];
    }
    return '';
  }

  /* Une boucle peut manquer sur un coloris. Plutôt que de laisser le client sur
   * un couple qui n'existe pas — bouton d'achat vivant, panier qui refuse — on
   * bascule sur la première boucle réellement disponible pour ce coloris. */
  function accorderBoucle(c) {
    if (!boucles.length || !table) return;
    var v = coupleDe(c.nom, boucle);
    if (v && v.dispo !== false) return;
    for (var i = 0; i < boucles.length; i++) {
      var essai = coupleDe(c.nom, boucles[i].nom);
      if (essai && essai.dispo !== false) { boucle = boucles[i].nom; return; }
    }
  }

  function choisirBoucle(nom) {
    if (!couleurs.length) return;
    boucle = nom;
    choisir((courant || couleurs[0]).nom);
  }

  // L'état des pastilles de boucle : celle qui est choisie, et celles que le
  // coloris courant ne propose pas.
  function majBoucles() {
    if (!boucles.length) return;
    var nomEl = document.querySelector('.mm-colors__name2');
    if (nomEl) nomEl.textContent = boucle;

    var btns = document.querySelectorAll('[data-boucle]');
    for (var i = 0; i < btns.length; i++) {
      var n = btns[i].dataset.boucle;
      btns[i].setAttribute('aria-pressed', String(n === boucle));
      var v = courant ? coupleDe(courant.nom, n) : null;
      var absent = !!(table && (!v || v.dispo === false));
      btns[i].disabled = absent;
      btns[i].classList.toggle('is-out', absent);
    }
  }

  /* L'accordéon Description porte le récit du modèle, puis le texte du coloris.
   * Le second est remplacé à chaque clic ; le premier ne bouge jamais.
   * Les textes des autres coloris restent dans le document, rendus par
   * qt-color.liquid : c'est ce qui met tous les textes sur une seule page. */
  function preparerDescription() {
    var corps = document.querySelector('.mm-acc .mm-a');
    if (!corps) return;
    corps.innerHTML = '<div class="mm-story-modele">' + (data.recit || '') + '</div>'
      + '<div data-qt-color-story></div>';
  }

  function choisir(nom) {
    var c = couleurs.filter(function (x) { return x.nom === nom; })[0];
    if (!c) return;
    courant = c;
    accorderBoucle(c);
    var id = varianteDe(c);

    // 1 · l'identifiant envoyé au panier
    var champ = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (champ) champ.value = id;

    // 2 · les photos — y compris au premier appel : la vue de départ porte le
    //     packshot du premier coloris, qui n'est pas forcément celui que
    //     l'adresse demande. Rien à faire quand aucune vue n'appartient à une
    //     valeur en particulier.
    if (!sansPhotos && (solo || !filtrerGalerie(c))) remplacerPhoto(c);

    // 3 · le nom et l'accroche
    var nomEl = document.querySelector('.mm-colors__name');
    if (nomEl) nomEl.textContent = c.nom;
    var note = document.querySelector('.mm-colors__note');
    if (note) note.textContent = c.accroche || '';

    // 4 · l'état des pastilles
    var all = document.querySelectorAll('.mm-swatch');
    for (var i = 0; i < all.length; i++) {
      if (all[i].dataset.boucle) continue;
      all[i].setAttribute('aria-pressed', String(all[i].dataset.couleur === nom));
    }

    // 5 · la barre d'achat collante, qui garde sinon le coloris de départ
    var sticky = document.querySelector('.mm-sticky');
    if (sticky) {
      var t = sticky.querySelector('.mm-sticky-title');
      if (t) t.textContent = data.titre + ' — ' + c.nom + (boucles.length ? ' · ' + boucle : '');
      var v = sticky.querySelector('img');
      if (v && photoDe(c)) {
        v.src = aLargeur(photoDe(c), 120);
        v.removeAttribute('srcset');
      }
    }

    // 6 · le texte long, dans l'accordéon Description
    var desc = document.querySelector('[data-qt-color-story]');
    if (desc) desc.innerHTML = c.texte || '';

    // 7 · l'état des pastilles de boucle, que le coloris vient peut-être de
    //     rendre indisponibles
    majBoucles();

    // 8 · l'adresse, pour qu'un partage de lien retombe sur le bon coloris
    if (window.history && history.replaceState) {
      var u = new URL(window.location.href);
      u.searchParams.set('variant', id);
      history.replaceState({}, '', u);
    }
  }

  /* Monte le sélecteur s'il n'est pas déjà là.
   *
   * Appelé au chargement, mais aussi sur les événements de l'éditeur de thème :
   * l'éditeur re-rend la section produit à chaque clic, ce qui efface notre
   * bloc et fait réapparaître le sélecteur natif. Sans ce rattrapage, la page
   * est correcte pour les clients mais cassée sous les yeux du marchand — ce
   * qui revient au même, puisque c'est là qu'il la juge. */
  function assurer() {
    if (document.querySelector('.mm-colors')) return;
    panel = document.querySelector('.mm-panel');
    buy = panel && panel.querySelector('.mm-buy');
    if (panel && buy) construire();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', assurer);
  } else {
    assurer();
  }

  document.addEventListener('shopify:section:load', assurer);
  document.addEventListener('shopify:section:select', assurer);
  document.addEventListener('shopify:block:select', assurer);
})();